/* eslint-disable max-lines */
import InfoCardStat from "@/components/infoCardStat/InfoCardStat.vue";
import RedArrow from "@/assets/img/arrow-red.svg";
import GreenArrow from "@/assets/img/arrow-green.svg";
import { sort } from "@/mixins/sort.js";
import RadioToggler from "@/components/radioToggler/RadioToggler.vue";
import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
import ItemTable from "./../itemTable/ItemTable.vue";
import utils from "@/utils.js";
import PeakGraph from "@/components/peakGraph/PeakGraph.vue";
import Number from "@/components/numberComponent/number.vue";
import { ChevronRightIcon } from "vue-feather-icons";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: filtersGetters } = createNamespacedHelpers("filters"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	name: "CategoryListing",
	props: {
		categoryOverviewData: {
			type: [Object, Array],
			required: true,
		},
		wasteSourceWithTranslations: {
			type: [Object, Array],
			required: true,
		},
		dataStatus: {
			type: Object,
			required: true,
		},
	},
	mixins: [sort],
	components: {
		InfoCardStat,
		RadioToggler,
		ToggleWeightCost,
		ItemTable,
		PeakGraph,
		Number,
		ChevronRightIcon,
	},
	data() {
		return {
			isCostToggleActive: false,
			categoryListingData: {},
			redArrow: RedArrow,
			greenArrow: GreenArrow,
			comparePeriodKey: "",
			comparePeriodValue: "",
			wasteWeightStatus: {},
			wasteCostStatus: {},
			language: localStorage.getItem("language") || "en",
			activeCategory: null,
			activeVisual: "serviceTime",
			itemCount: 8,
			utils: utils,
			serviceTimesLegend: ["morning", "day", "evening"],
			sourceLegend: ["production", "plate", "preparation"],
			colorsPercentageData: {},
			categoryItemPerformanceGraphData: [],
			categoryItemPerformanceGraphDataStatus: {
				showLoader: true,
				dataLoadFailed: false,
			},
			wastePerCategoryItemData: [],
			wastePerCategoryItemDataStatus: {
				showLoader: true,
				dataLoadFailed: false,
			},
			graphLoaded: false,
			showWastePerCategoryAccordion: false,
			isYear: false,
			closeAccordions: false,
		};
	},

	computed: {
		colors,
		...userGetters(["activeOutlet", "weightUnit", "serviceTimeSets"]),

		...filtersGetters(["activePeriod", "activeCompareTo"]),
		...brandingGetters(["serviceTimesColors", "sourceWasteColors"]),
	},

	methods: {
		setComparePeriodKey,
		setComparePeriodValue,
		getItemName,
		getWasteWeight,
		getWasteCost,
		parseData,
		setActiveCategory,
		getWastePerCategoryItem,
		getCategoryItemPerformanceGraph,
		setActiveVisual,
		sortWastePerCategoryItemData,
		toggleGraph,
		loadMoreItems,
		calculateTotal,
		init,
		handleCategoryImagesClick,
	},
	watch: {
		isCostToggleActive() {
			this.sortWastePerCategoryItemData();
			this.closeAccordions = true;
		},
		categoryOverviewData: function () {
			this.init();
		},
		wasteSourceWithTranslations: function () {
			this.init();
		},
	},
	mounted() {
		this.init();
		this.$eventBus.$on("reloadComponentData", this.init);
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadComponentData", this.init);
	},
};

function calculateTotal(key) {
	const kgModifier = 1000;
	let result = 0;

	// eslint-disable-next-line no-magic-numbers
	if (this.categoryListingData.length > 0) for (const element of this.categoryListingData) result += element[key];

	return key === "gross_weight" ? Math.round(result / kgModifier) : Math.round(result);
}

function loadMoreItems() {
	// eslint-disable-next-line no-magic-numbers
	if (this.itemCount <= this.wastePerCategoryItemData.length - 1) this.itemCount += 8;
	else this.itemCount = this.wastePerCategoryItemData.length;
}

function toggleGraph(item) {
	this.closeAccordions = false;
	this.getCategoryItemPerformanceGraph(item.id);
	this.$ma.trackEvent({
		action: "Category Over Time Click",
		properties: {
			Value: item.name,
			Component: this.$route.name,
		},
	});
}

function setActiveCategory(index, categoryId, name) {
	this.activeCategory = index === this.activeCategory ? null : index;
	this.categoryItemPerformanceGraphData = [];
	this.itemCount = 8;
	this.isCostToggleActive = false;
	this.setActiveVisual("serviceTime");

	if (this.activeCategory !== null) this.getWastePerCategoryItem(categoryId);

	this.$ma.trackEvent({
		action: "Category click",
		properties: {
			Value: name,
			Component: this.$route.name,
		},
	});

	this.sortWastePerCategoryItemData();
}

function sortWastePerCategoryItemData() {
	// eslint-disable-next-line no-magic-numbers
	if (this.wastePerCategoryItemData.length > 1) {
		const key = this.isCostToggleActive ? "cost" : "gross_weight";

		// eslint-disable-next-line no-magic-numbers
		this.wastePerCategoryItemData.sort((first, second) => (first[key] < second[key] ? 1 : -1));
	}
}

function setActiveVisual(value) {
	this.activeVisual = value;

	this.$ma.trackEvent({
		action: "Category Service time / source toggle",
		properties: {
			Value: value,
			Component: this.$route.name,
		},
	});
}

function colors() {
	const colorsData = this.activeVisual === "serviceTime" ? this.serviceTimesColors : this.sourceWasteColors,
		legend = this.activeVisual === "serviceTime" ? this.serviceTimesLegend : this.sourceLegend;

	return legend.map((label) => colorsData[label]);
}

function getWasteWeight(value) {
	const kgModifier = 1000;

	return Math.round(value / kgModifier);
}

function getWasteCost(value) {
	return Math.round(value);
}

function setComparePeriodKey() {
	this.isYear = typeof this.activeCompareTo === "number";
	this.comparePeriodKey = this.isYear ? this.activeCompareTo : this.activePeriod;
}

function setComparePeriodValue() {
	this.comparePeriodValue = this.activeCompareTo;
}

function getItemName(translations) {
	let name;

	translations.forEach((element) => {
		if (element.language_code === this.language) name = element.category_name;
	});

	return name;
}

function parseData() {
	this.categoryListingData = JSON.parse(JSON.stringify(this.categoryOverviewData));
	// eslint-disable-next-line no-magic-numbers
	if (this.categoryListingData.length > 1) {
		// Sort category per gross_weight, put "other" category (id=1) in the last position
		this.categoryListingData
			// eslint-disable-next-line no-magic-numbers
			.sort((first, second) => {
				if (first.category_id === 1) return 1;
				if (second.category_id === 1) return -1;
				return first.gross_weight < second.gross_weight ? 1 : -1;
			});
	}
	this.rearrangeItems(this.categoryListingData, ["menu"], "category_name");
}

function getWastePerCategoryItem(itemId) {
	this.wastePerCategoryItemData = [];
	this.showWastePerCategoryAccordion = false;
	this.wastePerCategoryItemDataStatus = {
		showLoader: true,
		dataLoadFailed: false,
	};

	this.$api
		.getWastePerCategoryItem(itemId)
		.then((response) => {
			this.wastePerCategoryItemData = response.data;

			this.sortWastePerCategoryItemData();
			this.showWastePerCategoryAccordion = true;
			this.wastePerCategoryItemDataStatus.showLoader = false;
		})
		.catch(() => {
			this.wastePerCategoryItemDataStatus.showLoader = false;
			this.wastePerCategoryItemDataStatus.dataLoadFailed = true;
		});
}

async function getCategoryItemPerformanceGraph(labelId) {
	if (labelId === null) return;

	this.categoryItemPerformanceGraphData = [];
	this.categoryItemPerformanceGraphDataStatus = {
		showLoader: true,
		dataLoadFailed: false,
	};

	try {
		const response = await this.$api.getCategoryItemPerformanceGraph(labelId),
			comparator = await this.$api.getCategoryItemPerformanceGraph(labelId, "compare");

		this.categoryItemPerformanceGraphData.push(response.data);
		this.categoryItemPerformanceGraphData.push(comparator.data);

		this.categoryItemPerformanceGraphDataStatus.showLoader = false;
	} catch {
		this.categoryItemPerformanceGraphDataStatus.showLoader = false;
		this.categoryItemPerformanceGraphDataStatus.dataLoadFailed = true;
	}
}

function init() {
	this.closeAccordions = true;
	this.activeCategory = null;
	this.itemCount = 8;
	this.setComparePeriodKey();
	this.setComparePeriodValue();
	this.sortWastePerCategoryItemData();
	this.parseData();
}

function handleCategoryImagesClick(category) {
	this.$eventBus.$emit("loadItemTrashEvents", { group_id: category.category_id });
	this.$ma.trackEvent({
		action: "Category Item View Images Click",
		properties: {
			Value: category.category_name,
			Component: this.$route.name,
		},
	});
}
